import cx from "classnames";
import "./Icon.scss";

/**
 * List of every IconType available in the icon file.
 * This list is currently non-exhaustive, it should be completed as needed.
 */
export enum IconType {
  NAV_BOTTOM = "icon-nav-bottom",
  NAV_TOP = "icon-nav-top",
  MARKER = "icon-marker",
  NAV = "icon-nav",
  CLOSE = "icon-close",
  ON_DEMAND = "icon-ondemand"
}

export interface IconProps {
  type: IconType;
  className?: string;
}

const Icon = ({ type, className }: IconProps) => {
  const basePath = global.drupalSettings?.sq?.theme?.iconSourcePath || "/themes/cws/icons/sqicons.svg";
  const classes = cx("Icon", `Icon--${type}`, className);

  // Render

  return (
    <svg className={classes}>
      <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref={`${basePath}#${type}`} />
    </svg>
  );
};

export default Icon;
